import React, { useRef } from 'react';
import Card from 'ui/views/cards/Card';
import TextField from 'ui/elements/form/TextField';
import { Author, AuthorImage } from 'domain/shared/author';
import { nameOf } from 'domain/shared/author';
import { postInputFieldStyles } from './postInputFieldStyles';

interface Props {
  author: Author;
  onClick: () => void;
}

export default function PostUpdateField({ author, onClick }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    // Blur immediately to prevent caret from showing
    inputRef.current?.blur();
    onClick();
  };

  return (
    <Card>
      <div className="u-flex u-flex--gap-half">
        <AuthorImage author={author} size={43} />
        <TextField
          inputRef={inputRef}
          onClick={handleClick}
          placeholder={`What would you like to share, ${nameOf(author)?.split(' ')[0]}?`}
          sx={postInputFieldStyles}
          inputProps={{ readOnly: true }}
        />
      </div>
    </Card>
  );
}
